// 判断浏览器是否支持 WebP 格式
export const isWebpSupported = (() => {
  let isWebp = null
  
  return () => {
    if (isWebp !== null) {
      return isWebp
    }
    try {
      isWebp = document.createElement('canvas')
        .toDataURL('image/webp', '0.5')
        .indexOf('data:image/webp') === 0
    } catch (e) {
      isWebp = false
    }
    return isWebp
  }
})()

// 转换图片为 WebP 格式并添加宽度限制
export const transitionWebp = (url,width) => {
  if (!url || !isWebpSupported()) return url;
  return url.replace(
    /\.(?:png|jpe?g)$/,
    `$&?x-oss-process=image/format,webp/resize,w_${width}`
  );
};

export const getImgUrl = (url,width=300) => {
  let newUrl = "";
  if (typeof url !== "string") {
    newUrl = "";
    return newUrl;
  }
  // 如果是公司内部cdn图片才可以走webp
  if (
    url &&
    (url.includes("https://imagecdn.ymm56.com") ||
      url.includes("https://image.ymm56.com") ||
      url.includes("https://devimage.ymm56.com/"))
  ) {
    if (isWebpSupported()) {
      newUrl = transitionWebp(url,width);
      return newUrl;
    }
    // 不支持 webp 但仍然需要 resize
    newUrl = url + `?x-oss-process=image/resize,w_${width}`;
    return newUrl;
  }
  newUrl = url;
  return newUrl;
};
